import ReactGA from 'react-ga4';
import { EventMapService } from '../services'

const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID

export function initAnalytics() {
  if (import.meta.env.VITE_ENV !== 'prod') return 
  ReactGA.initialize(GA4_MEASUREMENT_ID);
}

export function trackEvent(name) {
  if (import.meta.env.VITE_ENV !== 'prod') return 
  ReactGA.event(name, {
    page_location: window.location.href,
    send_to: GA4_MEASUREMENT_ID,
    page_path: window.location.pathname,
    page_title: document.title  
    
  }
  );
}

const PENDING_CHECKOUT_KEY = 'pendingCheckout'

export function savePendingCheckout(data) {
  localStorage.setItem(PENDING_CHECKOUT_KEY, JSON.stringify(data))
}

export function getPendingCheckout() {
  const raw = localStorage.getItem(PENDING_CHECKOUT_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function clearPendingCheckout() {
  localStorage.removeItem(PENDING_CHECKOUT_KEY)
}

export function pushPurchaseDataLayer(sessionId = null) {
  const data = getPendingCheckout()
  if (!data) return

  const transactionId = sessionId || data.sessionId || `guest_${Date.now()}`

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: transactionId,
      value: data.price,
      currency: data.currency || 'BRL',
      items: [
        {
          item_name: data.name,
          price: data.price,
          quantity: 1,
          item_category: data.checkoutType === 'addon' ? 'Pacote de Artes' : 'Plano',
        },
      ],
    },
    plan_name: data.name,
    plan_price: data.price,
    plan_type: data.checkoutType === 'addon' ? 'Pacote de Artes' : 'Plano',
    currency: data.currency || 'BRL',
  })
}

export async function registerCheckoutPurchaseEvent(sessionId = null) {
  const data = getPendingCheckout()
  if (!data) return false

  const event =
    data.checkoutType === 'addon'
      ? 'user_package_purchase'
      : 'user_subscription_purchase'

  const eventData = {
    sessionId: sessionId || null,
    name: data.name,
    value: data.price,
    currency: data.currency || 'BRL',
    checkoutType: data.checkoutType,
    ...(data.packageCode ? { packageCode: data.packageCode } : {}),
  }

  try {
    const response = await EventMapService.postEventMap({ event, eventData })
    return response?.responseStatus === 200 || response?.responseStatus === 201
  } catch (error) {
    console.error('registerCheckoutPurchaseEvent error', error)
    return false
  }
}

export async function trackCheckoutPurchase(sessionId = null) {
  pushPurchaseDataLayer(sessionId)
  const saved = await registerCheckoutPurchaseEvent(sessionId)
  if (saved) {
    clearPendingCheckout()
  }
  return saved
}